export const titleCase = (value: string) => {
   if (!value) {
      return ''
   }
   const words = value.split(' ')
   return words
      .map(word => {
         return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ')
}

export const list = (values: string[]) => {
   if (!values) {
      return ''
   }
   return values.join(', ')
}

export const pluck = (values: object[], fieldname: string) => {
   if (!values) {
      return []
   }
   if (typeof values[0] !== 'object') {
      return values
   }
   const value: any = values[0]
   if (typeof value[fieldname] === 'string') {
      return values.map(v => (v as any)[fieldname])
   }
   return values.map(v => v.toString())
}

export const unique = (value: string[]) => {
   if (!value) {
      return value
   }
   return value.filter((item, idx, all) => all.indexOf(item) === idx)
}

export const sort = (value: string[]) => {
   if (!value) {
      return value
   }
   return value.sort((a: string, b: string) => a.localeCompare(b))
}

export const plural = (value: number, single: string, pluralForm: string) => {
   if (!pluralForm) {
      pluralForm = `${single}s`
   }
   if (value === 1) {
      return `${value} ${single}`
   }
   if (value === 0) {
      return `No ${plural}`
   }
   return `${value} ${plural}`
}
